<template>
  <div id="content">
    <div class="container" id="app">
    <!-- <div id="app"></div> -->
    <!-- built files will be auto injected -->
      <header class="masthead">
        <div id="banner" class="banner mb-3">
          <span class="title">{{nickname}}农药数字信息管理平台</span>
        </div>
      </header>

      <router-view @updateInfo="update"/>
    </div>

    <!-- Site footer -->
    <footer class="footer py-3">
      <div class="text-center">
        <span id="footer-text">{{nickname}}农药数字信息管理平台 </span><a href="http://nongxiao123.com" target="_blank">农销乐&copy;</a> 2021 版权所有 <a href="http://beian.miit.gov.cn/" target="_blank">京ICP备19023243号-7</a>
      </div>
    </footer>
  </div>
</template>

<script>
// import axios from 'axios'

// var BASE_URL = 'https://api.nongxiao123.com/yz'
// var info = null

export default {
  name: 'App',
  data () {
    return {
      // info: null
      nickname: ''
    }
  },
  methods: {
    update: function (info) {
      // console.log('update', info)
      this.nickname = info.nick
    }
  }
  // mounted() {
  //   console.log('App')

  //   var that = this

  //     axios.get(BASE_URL + '/common/govsite/list?url=' + name)
  //       .then(function (resp) {
  //         console.log('axios', resp.data.data)
  //         if (resp.data.data.length > 0) {
  //           console.log('Got info', resp.data.data[0])
  //           // that.getData(resp.data.data[0])
  //           that.info = resp.data.data[0]
  //         } else {
  //           console.log('Not found', name)
  //         }
  //       })
  //       .catch(function (error) {
  //         console.log('axios error', error)
  //       })
  // }
}
</script>

<style>
#banner {
  background-image: url('./assets/banner.jpg');
  display: flex;
  justify-content: flex-start;
  padding: 50px;
}
span.title {
  align-self: center;
  font-size: 48px;
  color: #00366E;
  text-shadow: 0 0 9px white;
  animation:  glow 3s infinite;
}
@keyframes glow {
  0% {
    text-shadow:  0 0 10px white;
  }
  
  50% {
    text-shadow: 2px 2px 10px rgba(255, 255, 255, 1),
                 -2px -2px 10px rgba(255, 255, 255, 1);
  }
}

html {
  position: relative;
  min-height: 100%;
}
body {
  margin-bottom: 60px; /* Margin bottom by footer height */
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px; /* Set the fixed height of the footer here */
  /* line-height: 60px; */
}
.container {
  margin-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue